import { Link } from "react-router-dom";
import { ArrowRight, Home } from "lucide-react";
import { useEffect } from "react";

export default function NotFound() {
  useEffect(() => {
    document.title = "Pagina niet gevonden — SovEU";
    // Tell crawlers this is a real 404 (the static host should also serve 404 status)
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.setAttribute("name", "robots");
      document.head.appendChild(robots);
    }
    robots.setAttribute("content", "noindex, follow");
  }, []);

  return (
    <div data-testid="page-not-found" className="pt-[96px]">
      <section className="section bg-white">
        <div className="container-soveu max-w-2xl text-center">
          <div className="eyebrow mb-4">404</div>
          <h1 className="h1-display mb-6">Deze pagina bestaat niet meer</h1>
          <p className="body-lg text-[#334155] mb-9">
            De pagina die u zoekt is verplaatst of is niet langer beschikbaar.
            Vanuit hier vindt u alles terug.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-3">
            <Link
              to="/"
              className="btn-primary"
              data-testid="not-found-cta-home"
            >
              <Home size={18} />
              Naar home
            </Link>
            <Link
              to="/contact"
              className="btn-primary btn-ghost"
              data-testid="not-found-cta-contact"
            >
              Contact opnemen
              <ArrowRight size={18} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
